import styled from 'styled-components';

const CreateSurveyModalWrapper = styled.div`
  width: 400px;
`;

export default CreateSurveyModalWrapper;
